import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro'
import { theme } from 'styled-tools'
import { ReactComponent as ArrowDropDownIcon } from '../Icons/icon-chevron.svg'

import { em, rgba } from '../../utils/styles'


export const ArrowIcon = styled(ArrowDropDownIcon)`
  display: inline-block;
  margin-left: ${em(8)};
  width: ${em(16)};
  height: ${em(16)};
  transform: rotate(90deg);
`

const StyledButton = styled.button.attrs({
  type: 'button'
})`
  border: 0;
  background-color: transparent;
  display: flex;
  align-items: center;
  font-size: 1em;
  font-weight: ${theme('fontWeights.bold')};
  padding: ${em(8.5)} ${em(13)};
  text-align: right;
  cursor: pointer;

  &:focus {
    background-color: ${rgba('base', 0.1)};
  }

  &:hover ${ArrowIcon} {
    color: ${theme('colors.primary')};
  }
`

function DropdownButton({ children, ...props }) {
  return (
    <StyledButton {...props}>
      <span>
        {children}
      </span>
      <ArrowIcon />
    </StyledButton>
  )
}

DropdownButton.propTypes = {
  children: PropTypes.node
}

export default DropdownButton
